import { Box } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import { Pill } from '@scoir/pills'
import ScoirIcon from './ScoirIcon'

const ScoirPill = styled(Pill)(() => {
  return {
    background: 'rgba(33, 150, 243, 0.08)',
  }
})
const ScoirBadgeIconContainer = styled(Box)(({ theme }) => ({
  fill: '#15769a',
  marginRight: theme.spacing(0.5),
  height: 25,
  width: 25,
}))

export default function OnScoirBadge() {
  return (
    <ScoirPill>
      <ScoirBadgeIconContainer>
        <ScoirIcon />
      </ScoirBadgeIconContainer>
      On Scoir
    </ScoirPill>
  )
}
